import { render, staticRenderFns } from "./add-user-group-modal.vue?vue&type=template&id=a1c73dbc&"
import script from "./add-user-group-modal.vue?vue&type=script&lang=js&"
export * from "./add-user-group-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports